import React from 'react'
import { Form } from 'react-bootstrap'

const SelectField = ({ label, value, options=[], onChange, placeholder = '', className = 'mr-5' }) => {

  const handlerChange = (e) => {
    onChange(e.target.value)
  }

  return (
    <Form.Group className={className}>
      <Form.Label>{label}</Form.Label>
      <Form.Control as='select' onChange={ handlerChange } value={value}>        
        { placeholder && <option value=''>{placeholder}</option> }
        {
          options.map( option => 
            <option 
              key={option.value}
              value={option.value}
            >
              {option.label}
            </option>)
        }
      </Form.Control>
    </Form.Group>
  )
}

export default SelectField